module.exports = __webpack_public_path__ + "static/frontend-script-ee1f4beb5004d6023bd89d485311eb89.png";